import { API, doGet, doPost, doPut, doDelete } from "@/api/api.js"
import axios from "axios"
import { getPageMap } from "../config/page-config.js"
import { enumMap } from "../config/enum-config.js"

export default {
    data: function () {
        return {
            exportMap: [],
            exportChecked: [],
            isExport: false,
            tag: "",          //如：AMDIN、ROLE
            handle: "",       //insert、update、delete
            isHandle: false,  //是否弹窗
            handleInfo: {},   //当前正在操作的信息（insert为{}，update、delete为当前操作项）
            current: 1,
            size: 10,
            total: 0,
            records: [],
            pageMap: {},
            filterParams: {},
            referenceMap: {},  //所有关联的表都在此（表名为pageMap中的code，使用/all方法）
            permissionButtons: [],  //当前页面当前权限的功能按钮
        }
    },
    methods: {
        copyClick: function(text) {
            const ta = document.createElement('textarea')
            ta.value = text
            ta.style.position = 'fixed'
            ta.style.left = '-9999px'
            document.body.appendChild(ta)
            ta.select()
            document.execCommand('copy')
            document.body.removeChild(ta)
            this.$message.success('复制成功')
        },
        getEnumArray: function(tag) {
            if (tag) {
                console.log("tag")
                console.log(enumMap[tag]);
                return enumMap[tag];
            }
            return [];
        },
        getEnumLabel: function(tag, value) {
            return enumMap[tag].find(item => item.value == value).label;
        },
        exportOpen: function () {
            this.isExport = true;
        },
        exportConfirm: function () {
            let exportParam = JSON.parse(JSON.stringify(this.filterParams));
            exportParam.exportList = [];
            for (let i = 0; i < this.exportMap.length; i++) {
                if (this.exportChecked.includes(this.exportMap[i].name)) {
                    exportParam.exportList.push(this.exportMap[i].value);
                }
            }
            axios.get(process.env.VUE_APP_BASE_API + "/" + this.pageMap.code + "/export" + "?" + (new URLSearchParams(exportParam)).toString(), { 
                responseType: 'blob',
                headers: {
                    "auth-admin": localStorage.getItem("AUTH-ADMIN"),
                    "auth-company": localStorage.getItem("AUTH-COMPANY")
                }
            }).then(response => {
                    this.isExport = false;
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = (new Date()).getTime() + '.xlsx';
                    link.click();
                });
            // doGet(API.EXPORT.TICKET, this.filterParams);
        },
        sizeChange: function (size) {
            this.size = size;
            this.initialData();
        },
        currentChange: function (current) {
            this.current = current;
            this.initialData();
        },
        initialData: async function () {
            this.filterParams.current = this.current;
            this.filterParams.size = this.size;
            let datas = await doGet("/" + this.pageMap.code, this.filterParams);
            if (datas) {
                this.records = datas.records;
                this.current = datas.current;
                this.size = datas.size;
                this.total = datas.total;
            }
            if (this.afterInitialData) {    //钩子函数，数据初始化后自动触发
                this.afterInitialData();
            }
        },
        getModalTitle: function () {
            let title = "";
            switch (this.handle) {
                case "insert": title = "新增"; break;
                case "update": title = "修改"; break;
                case "delete": title = "删除"; break;
            }
            title += this.pageMap.name;
            return title;
        },
        handleClick: function (handle, info, customer) {
            this.handle = handle;
            this.isHandle = true;
            if (info) {
                this.handleInfo = JSON.parse(JSON.stringify(info));
            }
            else {
                this.handleInfo = {};
            }
            if (this.beforeHandleOpen) {    //钩子函数，打开窗口后自动触发
                this.beforeHandleOpen(handle);
            }
            if (this.beforeHandleOpenEx) {    //钩子函数，打开窗口后自动触发
                this.beforeHandleOpenEx(handle, info, customer);
            }
        },
        handleSubmit: async function () {
            let primaryColumn = this.pageMap.code + "Id";
            let resultObj;
            if (this.beforeHandleSubmit) {  //钩子函数，提交前自动触发
                this.beforeHandleSubmit();
            }
            switch (this.handle) {
                case "insert":
                    resultObj = await doPost("/" + this.pageMap.code, this.handleInfo);
                    break;
                case "update":
                    resultObj = await doPut("/" + this.pageMap.code, this.handleInfo);
                    break;
                case "delete":
                    resultObj = await doDelete("/" + this.pageMap.code, this.handleInfo[primaryColumn]);
                    break;
                case "show":
                    this.isHandle = false;
                    return;
                    break;
                default:
                    this.isHandle = false;
                    break;
            }
            if (this.afterHandleSubmit) {  //钩子函数，提交后自动触发
                this.afterHandleSubmit();
            }
            if (resultObj) {
                this.showResult(resultObj);
            }
        },
        showResult: function (resultObj) {
            if (resultObj.errorCode == 0) {
                this.$message.success(resultObj.errorMessage);
                this.isHandle = false;
                this.loadData();
            }
            else {
                this.$message.error(resultObj.errorMessage);
            }
        },
        showResultEx: function (resultObj) {
            if (resultObj.errorCode == 0) {
                this.$message.success(resultObj.errorMessage);
            }
            else {
                this.$message.error(resultObj.errorMessage);
            }
        },
        convertToDate: function (unixTime) {
            if (unixTime) {
                const date = new Date(unixTime * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            }
            else {
                return "--";
            }
        },
        initialReference: async function() {
            console.log("初始化引用数据");
            this.referenceMap = {};
            if (this.pageMap.form) { 
                for (let i = 0; i < this.pageMap.form.length; i++) {
                    if (this.pageMap.form[i].reference) {
                        let arr = await doGet("/" + this.pageMap.form[i].reference + API.ALL);
                        this.$set(this.referenceMap, this.pageMap.form[i].reference, arr);
                    }
                }
            }
        },
        loadData: function (current) {
            console.log("this.monthRange：" + this.monthRange);
            if (!this.tag) {
                return;
            }
            if (current) {
                this.current = current;
            }
            //初始化参数
            if (this.initialParam) {
                this.initialParam();
            }
            //初始化依赖数据
            this.initialReference();
            //初始化数据
            if (this.getData) {     //若在组件/页面中存在getData方法，则执行getData方法，若不存在则执行默认的initialData方法
                this.getData();
            }
            else {
                this.initialData();
            }
            if (this.reloadData) {
                this.reloadData();
            }
            //获取功能按钮权限
            this.getPermissionButtons();
        },
        getPermissionButtons: async function() {
            this.permissionButtons = await doGet(API.BUTTONS_BY_PERMISSION_ADMIN, { url: this.$route.path });
        },
        checkPermissionButton: function(name) {
            let result = false;
            for (let i = 0; i < this.permissionButtons.length; i++) {
                if (this.permissionButtons[i].sysPermissionButtonName == name) {
                    result = true;
                    break;
                }
            }
            return result;
        }
    },
    beforeMount: function () {
        if (!this.tag) {
            this.tag = this.$route.path;
        }
        this.pageMap = getPageMap(this.tag);
        this.loadData();
        try {
            this.exportChecked = [];
            for (let i = 0; i < this.exportMap.length; i++) {
                if (this.exportMap[i].checked) {
                    this.exportChecked.push(this.exportMap[i].name);
                }
            }
        }
        catch (error) {
            console.log(error);
        }
    }
}